import { Grid } from "@mui/material";
import { useMessage } from "hooks/intl";
import { camelCase } from "lodash";
import { useState } from "react";
import { FileRejection, FileWithPath } from "react-dropzone";
import { DragAndDrop } from "./DragAndDrop";
import { useStyles } from "./styles";

type Error = {
  file: string;
  errors: string[];
};
export type ImageType = {
  path: string;
  preview: string;
  status: "new" | "deleted" | "saved";
  id: string;
  file?: File;
};
type Props = {
  images: ImageType[];
  setImages: (images: ImageType[]) => void;
};

export function ImageUpload({ images, setImages }: Props) {
  const classes = useStyles();
  const { message } = useMessage();
  const [errors, setErrors] = useState<Error[]>();
  const onDelete = (image: ImageType) => {
    const { status } = image;
    const imageCopy = [...images];
    const imageIndex = imageCopy.findIndex((img) => img.id === image.id);
    setErrors([]);

    switch (status) {
      case "new":
        // remove from array
        imageCopy.splice(imageIndex, 1);
        return setImages(imageCopy);
      case "saved":
        // set status deleted
        imageCopy[imageIndex].status = "deleted";

        return setImages(imageCopy);
    }
  };

  const onChange = (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
    if (rejectedFiles) {
      const errors = rejectedFiles.map((rejected) => {
        return {
          errors: rejected.errors.map(
            (err: { code: string; message: string }) => err.code,
          ),
          file: rejected.file.name,
        };
      });
      setErrors(errors);
    }
    setImages([
      ...images,
      ...acceptedFiles.map(
        (file: FileWithPath) =>
          ({
            id: URL.createObjectURL(file),
            path: file.path || "",
            preview: URL.createObjectURL(file),
            status: "new",
            file: file,
          }) as ImageType,
      ),
    ]);
  };

  return (
    <Grid alignItems="flex-start" container>
      {errors &&
        errors.map((error, index) => {
          return (
            <div className={`${classes.error} error-anchor`} key={index}>
              <span>{error.file}</span>:{" "}
              {error?.errors?.map((err, index) => (
                <span key={index}>{message({ id: camelCase(err) })}</span>
              ))}
            </div>
          );
        })}

      <Grid item xs={12}>
        <DragAndDrop
          header={message({
            id: "uploadImages",
          })}
          onChange={onChange}
          onDelete={onDelete}
          value={images.filter(({ status }) => status !== "deleted")}
        />
      </Grid>
    </Grid>
  );
}
